import { render } from "./SelectTariff.vue?vue&type=template&id=15e52335&scoped=true"
import script from "./SelectTariff.vue?vue&type=script&lang=js"
export * from "./SelectTariff.vue?vue&type=script&lang=js"

import "./SelectTariff.vue?vue&type=style&index=0&id=15e52335&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e52335"]])

export default __exports__